/**
 * New accounts' onboarding, as the onboardingLibrary1 experiment decides it
 * (docs/experiments/2026-10-onboardingLibrary1.md): its arm starts on
 * Discover under a "Start here" section (StartHereView), and Home's checklist
 * has buttons rather than instructions (WalkthroughChecklistView).
 */
import * as experiment from "experiment";
import * as experimentUtils from "shared/experimentUtils";

const experimentName = "onboardingLibrary1";

/**
 * Whether the account, or the visitor trying Readlang without one, gets the
 * new onboarding. Treats them, in either arm, if new enough for the
 * experiment, so call it only where the arms diverge. A visitor's ID is their
 * session's, which becomes their account's if they sign up, keeping the arm.
 */
export const libraryOnboarding = (): boolean => {
  const userID = window.READLANG.userID;
  return (
    Boolean(userID) &&
    experimentUtils.isEligibleForCohort(userID, experimentName) &&
    experiment.getConditionAndTreat(experimentName) === "experiment"
  );
};

/** Where /start leads, signed up or trying it out, with nowhere in particular to go */
export const firstPagePath = () =>
  libraryOnboarding() ? "/library" : "/dashboard";
